/**
 * @file GENERATED by `npm run sfx` (`tools/build-sfx.mjs`). DO NOT EDIT.
 *
 * The shipped clip inventory: which files exist, how long they are, and where a
 * looping clip's seamless region starts and ends. Nothing in here is a taste
 * decision — the mix lives next door in `src/game/sfx.js`, which is AUTHORED
 * and is the file to edit when something is too loud.
 *
 * ⚠ VARIANT ORDER IS THE CONTRACT. The runtime picks a variant by INDEX, and
 * for the sticky slugs (a car keeps its engine, a police car keeps its siren)
 * that index is hashed from an entity key — so reordering this list silently
 * repaints every car in the game with a different engine note. The order is
 * the source `_v<N>` order, densely renumbered from 1.
 *
 * Durations are of the ENCODED MP3, so they include encoder padding. Loop
 * points are deliberately NOT here — they are measured against the browser's
 * own decode at load time; see `tools/build-sfx.mjs` for why that is the only
 * decoder whose answer counts.
 */

export const AUDIO_BASE = "/audio";

/** @type {Record<string, {kind: "oneshot"|"loop", files: string[], dur: number[]}>} */
export const SFX_ASSETS = {
  gunshot: {
    kind: "oneshot",
    files: ["gunshot_1.mp3", "gunshot_2.mp3", "gunshot_3.mp3"],
    dur: [0.6, 0.55, 0.59],
  },
  groan: {
    kind: "oneshot",
    files: ["groan_1.mp3", "groan_2.mp3", "groan_3.mp3"],
    dur: [0.4, 0.49, 0.49],
  },
  footstep: {
    kind: "oneshot",
    files: ["footstep_1.mp3", "footstep_2.mp3", "footstep_3.mp3", "footstep_4.mp3", "footstep_5.mp3", "footstep_6.mp3", "footstep_7.mp3", "footstep_8.mp3", "footstep_9.mp3", "footstep_10.mp3", "footstep_11.mp3", "footstep_12.mp3", "footstep_13.mp3", "footstep_14.mp3", "footstep_15.mp3", "footstep_16.mp3"],
    dur: [0.3, 0.3, 0.3, 0.3, 0.3, 0.162, 0.3, 0.3, 0.3, 0.3, 0.284, 0.3, 0.3, 0.3, 0.3, 0.19],
  },
  car_crash: {
    kind: "oneshot",
    files: ["car_crash_1.mp3", "car_crash_2.mp3"],
    dur: [0.96, 2.57],
  },
  car_start: {
    kind: "oneshot",
    files: ["car_start_1.mp3", "car_start_2.mp3", "car_start_3.mp3"],
    dur: [3.45, 3.2, 1.9],
  },
  car_engine: {
    kind: "loop",
    files: ["car_engine_1.mp3"],
    dur: [8],
  },
  siren_police: {
    kind: "loop",
    files: ["siren_police_1.mp3", "siren_police_2.mp3"],
    dur: [5.195, 5.04],
  },
  siren_ambulance: {
    kind: "loop",
    files: ["siren_ambulance_1.mp3", "siren_ambulance_2.mp3"],
    dur: [4.651, 5.68],
  },
  prop_smash: {
    kind: "oneshot",
    files: ["prop_smash_1.mp3", "prop_smash_2.mp3", "prop_smash_3.mp3"],
    dur: [0.42, 0.5, 0.8],
  },
  door: {
    kind: "oneshot",
    files: ["door_1.mp3", "door_2.mp3", "door_3.mp3"],
    dur: [0.68, 1.06, 1.16],
  },
  rain: {
    kind: "loop",
    files: ["rain_1.mp3", "rain_2.mp3"],
    dur: [22.506, 21.493],
  },
  drone: {
    kind: "loop",
    files: ["drone_1.mp3"],
    dur: [3.019],
  },
  phone_ring: {
    kind: "oneshot",
    files: ["phone_ring_1.mp3", "phone_ring_2.mp3"],
    dur: [8.29, 8.6],
  },
  phone_key: {
    kind: "oneshot",
    files: ["phone_key_1.mp3", "phone_key_2.mp3", "phone_key_3.mp3"],
    dur: [0.195, 0.22, 0.225],
  },
  cash: {
    kind: "oneshot",
    files: ["cash_1.mp3", "cash_2.mp3"],
    dur: [1.66, 1.54],
  },
  text_notify: {
    kind: "oneshot",
    files: ["text_notify_1.mp3"],
    dur: [0.36],
  },
  ui_notify: {
    kind: "oneshot",
    files: ["ui_notify_1.mp3"],
    dur: [0.33],
  },
};

/** Every shipped clip filename, flat — the preloader walks this. */
export const SFX_FILES = Object.freeze([
  "gunshot_1.mp3",
  "gunshot_2.mp3",
  "gunshot_3.mp3",
  "groan_1.mp3",
  "groan_2.mp3",
  "groan_3.mp3",
  "footstep_1.mp3",
  "footstep_2.mp3",
  "footstep_3.mp3",
  "footstep_4.mp3",
  "footstep_5.mp3",
  "footstep_6.mp3",
  "footstep_7.mp3",
  "footstep_8.mp3",
  "footstep_9.mp3",
  "footstep_10.mp3",
  "footstep_11.mp3",
  "footstep_12.mp3",
  "footstep_13.mp3",
  "footstep_14.mp3",
  "footstep_15.mp3",
  "footstep_16.mp3",
  "car_crash_1.mp3",
  "car_crash_2.mp3",
  "car_start_1.mp3",
  "car_start_2.mp3",
  "car_start_3.mp3",
  "car_engine_1.mp3",
  "siren_police_1.mp3",
  "siren_police_2.mp3",
  "siren_ambulance_1.mp3",
  "siren_ambulance_2.mp3",
  "prop_smash_1.mp3",
  "prop_smash_2.mp3",
  "prop_smash_3.mp3",
  "door_1.mp3",
  "door_2.mp3",
  "door_3.mp3",
  "rain_1.mp3",
  "rain_2.mp3",
  "drone_1.mp3",
  "phone_ring_1.mp3",
  "phone_ring_2.mp3",
  "phone_key_1.mp3",
  "phone_key_2.mp3",
  "phone_key_3.mp3",
  "cash_1.mp3",
  "cash_2.mp3",
  "text_notify_1.mp3",
  "ui_notify_1.mp3",
]);
